import barba from '@barba/core';
import gsap from 'gsap';

const barbaUrlsToPrevent = [
  'wp/wp-admin',
  'wp/wp-login',
  'app/uploads/',
];

// See https://github.com/barbajs/barba/issues/51
const getBodyClass = html => $(html.replace(/(<\/?)body( [\s\S]+?)?>/gi, '$1notbody$2>')).filter('notbody').attr('class');

// Helper function that reinits Contact Form 7 forms after barba page transition
// @todo Check barbajs namespace and rules docs to see if there's a way to only trigger this function in contact page
const initWpCf7Form = () => {
  if (!window.wpcf7) {
    return;
  }

  $('.wpcf7 > form.wpcf7-form').each((i, formNode) => {
    window.wpcf7.init(formNode);
  });
};

// Render WPCF7 recaptcha
// This should be run in the after Barba hooks to make sure it's not already rendered
const initWpcf7Recaptcha = () => {
  if (typeof window.recaptchaCallback === 'function') {
    const $recaptcha = $('form .wpcf7-recaptcha');

    if ($recaptcha.length && !$recaptcha.html()) {
      window.recaptchaCallback();
    }
  }
};

// Render WPCF7 turnstile
// This should be run in the after Barba hooks to make sure it's not already rendered
const initWpcf7Turnstile = () => {
  if (typeof window?.turnstile?.render === 'function') {
    const $turnstile = $('form .wpcf7-turnstile');

    if ($turnstile.length) {
      $turnstile.each((i, el) => {
        const $el = $(el);
        if ($el.html()) {
          return;
        }

        const sitekey = $el.data('sitekey');
        window.turnstile.render($el.get(0), { sitekey });
      });
    }
  }
};

const triggerGtagPageView = pagePath => {
  if (typeof window.gtag === 'function') {
    window.gtag('set', 'page_path', pagePath);
    window.gtag('event', 'page_view');
  } else if (typeof window.ga === 'function') {
    window.ga('set', 'page', pagePath);
    window.ga('send', 'pageview');
  }
};

const pageTransition = handler => {
  const $body = $(document.body);
  const $loadingScreen = $('.loading-screen');

  const pageTransitionIn = () => {
    return gsap.to($loadingScreen.get(0), {
      duration: 0.3,
      scaleY: 1,
      transformOrigin: 'bottom left',
    });
  };

  const pageTransitionOut = () => {
    return gsap
      .timeline({ delay: 0.5 })
      .add('start')
      .to($loadingScreen.get(0), {
        duration: 0.3,
        scaleY: 0,
        skewX: 0,
        transformOrigin: 'top left',
        ease: 'power1.out',
      }, 'start')
  };

  barba.init({
    debug: true,
    transitions: [{
      name: 'page-transition',
      async leave({ current }) {
        await pageTransitionIn();
        current.container.remove();
      },
      async enter() {
        await pageTransitionOut();
      },
    }],
    prevent: ({ el }) => {
      const href = $(el).attr('href');

      return href && barbaUrlsToPrevent.reduce((hasToPrevent, url) => {
        if (!hasToPrevent) {
          hasToPrevent = href.indexOf(url) !== -1;
        }

        return hasToPrevent;
      }, false);
    },
  });

  barba.hooks.leave(() => {
    $body.removeClass('offcanvas');
    $('.js-nav-toggle').removeClass('active')
  });

  barba.hooks.beforeEnter(({ next }) => {
    if (next.html) {
      $(document.body).attr('class', getBodyClass(next.html));
    }

    handler.beforeRun();
    initWpCf7Form();
  });

  barba.hooks.enter(() => {
    window.scrollTo(0, 0);
  });

  barba.hooks.after(({ next }) => {
    handler.run();

    if (next?.url.path) {
      triggerGtagPageView(next.url.path);
    }

    initWpcf7Recaptcha();
    initWpcf7Turnstile();
  });
};

export default pageTransition;


